import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeStatusCron2'
})
export class PipeStatusCron2 implements PipeTransform {
    constructor() {}
    transform(url) {
        if(url == 'Parado'){
            return 'text-secondary';
        } else if(url == 'Iniciado'){
            return 'text-warning';
        } else if(url == 'Concluido' || url == 'Concluído'){
            return 'text-success';
        } else {
            return 'text-danger';
        }
      }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeStatusCron2.ts